(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
	closeSearchModal(){
		const searchCloseButton = document.querySelector('.main-search__close');
		if (document.body.classList.contains('show-search') && searchCloseButton) {
			searchCloseButton.click();
		}
	}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('discount-box')) {
    customElements.define(
      'discount-box',
      class discountBox extends HTMLElement {
        constructor() {
          super();

          this.input = this.querySelector('.cart-discount-box__input');
          this.submitBtn = this.querySelector('.cart-discount-box__submit');
          this.clearBtn = this.querySelector('.cart-discount-box__active-clear');
          this.subtotaL = document.querySelector('.subtotal .theme-money');

// if (localStorage.discountCode) this.applyDiscount(JSON.parse(localStorage.discountCode).code);

          this.submitBtn.addEventListener('click', this.onSubmit.bind(this));

          this.clearBtn.addEventListener('click', this.onClear.bind(this));
        }

        onSubmit(event) {
          event.preventDefault();

          if (this.input.value == '') {
            this.input.focus();
            return;
          }

          this.applyDiscount(this.input.value);
        }
        onClear(event) {
          event.preventDefault();
          this.clearDiscount();
        }

        clearDiscount() {
          this.querySelector('.cart-discount-box__active-value').innerHTML = '';
          this.querySelector('.cart-discount-box__error').innerHTML = '';
          this.clearLocalStorage();
          fetch('/discount/CLEAR')
            .then((response) => response.text())
            .then((data) => {
              fetch('/checkout');
              if (document.querySelector('.cart-discount-list')) {
                document.querySelector('.cart-discount-list').remove();
              }
            });
        }

        clearLocalStorage() {
          this.querySelector('.cart-discount-box__active-wrapper').setAttribute('hidden', true);
          if (localStorage.discountCode) {
            this.subtotaL.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
            localStorage.removeItem('discountCode');
          }
        }

        applyDiscount(code) {
          this.submitBtn.classList.add('cart-discount-box__submit--loading');
          const fetchConfig = {
            headers: {
              'Content-Type': 'application/json',
              Accept: `application/json`,
            },
          };
          fetch(`/payments/config`, {
            ...fetchConfig,
            ...{ method: 'GET' },
          })
            .then((response) => response.json())
            .then((data) => {
              const checkout_json_url = '/wallets/checkouts/';
              this.authorization_token = btoa(data.paymentInstruments.accessToken);
              fetch(`${theme.routes.cart_url}`, {
                ...fetchConfig,
                ...{ method: 'POST' },
              })
                .then((res) => res.json())
                .then((data) => {
                  const body = {
                    checkout: {
                      discount_code: code,
                      line_items: data.items,
                      presentment_currency: Shopify.currency.active,
                    },
                  };
                  fetch(`${checkout_json_url}`, {
                    headers: {
                      accept: '*/*',
                      'cache-control': 'no-cache',
                      authorization: 'Basic ' + this.authorization_token,
                      'content-type': 'application/json, text/javascript',
                      pragma: 'no-cache',
                      'sec-fetch-dest': 'empty',
                      'sec-fetch-mode': 'cors',
                      'sec-fetch-site': 'same-origin',
                    },
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    body: JSON.stringify(body),
                  })
                    .then((response) => {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error('Please Enter Valid Coupon Code.');
                    })
                    .then((data) => {
                      if (data.checkout && data.checkout.applied_discounts.length > 0) {
                        let discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkout/';
                        fetch(`${discountApplyUrl}`, {}).then((response) => response.text());
                        this.querySelector('.cart-discount-box__active-wrapper').removeAttribute('hidden');
                        this.querySelector('.cart-discount-box__error').innerHTML = '';
                        this.querySelector('.cart-discount-box__active-value').innerHTML =
                          data.checkout.applied_discounts[0].title +
                          ' (' +
                          data.checkout.applied_discounts[0].amount +
                          ' ' +
                          Shopify.currency.active +
                          ')';
                        let localStorageValue = {
                          code: code.trim(),
                          totalCart: data.checkout.total_line_items_price,
                        };
                        localStorage.setItem('discountCode', JSON.stringify(localStorageValue));
                        this.subtotaL.innerHTML = `<s>${data.checkout.total_line_items_price}</s> ${data.checkout.total_price}`;
                      } else {
                        this.querySelector('.cart-discount-box__active-value').innerHTML = '';
                        this.clearLocalStorage();
                        this.querySelector('.cart-discount-box__error').innerHTML = 'Please Enter Valid Coupon Code.';
                      }
                    })
                    .catch((e) => {
                      this.querySelector('.cart-discount-box__active-value').innerHTML = '';
                      this.clearLocalStorage();
                      this.querySelector('.cart-discount-box__error').innerHTML = 'Please Enter Valid Coupon Code.';
                    })
                    .finally((params) => {
                      this.submitBtn.classList.remove('cart-discount-box__submit--loading');
                    });
                });
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class collectionGridBanner extends HTMLElement {
    constructor() {
      super();
      const products = document.querySelectorAll('.product-list .product-block');
      const position = parseInt(this.dataset.position);
      const _this = this;
      products.forEach(function (product, index) {
        index += 1;
        if (position === index) {
          product.parentNode.insertBefore(_this.querySelector('.collection_grid_banner'), product);
          return false;
        }
      });
      this.remove();
    }
  }
  customElements.define('grid-banner', collectionGridBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
